import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import PageBreadcrumbs from "@insite/content-library/Components/PageBreadcrumbs";
import Page from "@insite/mobius/Page";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";
import { ReactNode } from "react";
import { css } from "styled-components";
import styled from "styled-components";

interface PageLayoutProps {
    showHeader: boolean;
    header: ReactNode;
    showCompactHeader: boolean;
    compactHeader: ReactNode;
    showBreadcrumbs: boolean;
    pageContent: ReactNode;
    showFooter: boolean;
    footer: ReactNode;
    showSignInOverlay?: boolean;
    signInOverlay?: ReactNode;
    showStorePickupOverlay?: boolean;
    storePickupOverlay?: ReactNode;
    showAddressBookOverlay?: boolean;
    addressBookOverlay?: ReactNode;
}

interface PageLayoutStyles {
    wrapper?: InjectableCss;
    breadcrumbWrapper?: InjectableCss;
}

const styles: PageLayoutStyles = {
    wrapper: {
        css: css`
            background-color: white;
            min-height: 600px;
        `,
    },
    breadcrumbWrapper: {
        css: css`
            padding: 15px 0;
            ${({ theme }) => {
                const { maxWidths } = theme.breakpoints;
                return breakpointMediaQueries(theme, [
                    css`
                        max-width: ${maxWidths[0]}px;
                    `,
                    css`
                        max-width: ${maxWidths[1]}px;
                    `,
                    css`
                        max-width: ${maxWidths[2]}px;
                    `,
                    css`
                        max-width: ${maxWidths[3]}px;
                    `,
                    css`
                        max-width: ${maxWidths[4]}px;
                    `,
                ]);
            }}
        `,
    },
};

// This doesn't currently support HMR
const PageLayout = ({
    showHeader,
    header,
    showBreadcrumbs,
    pageContent,
    showFooter,
    footer,
    showCompactHeader,
    compactHeader,
    showSignInOverlay,
    signInOverlay,
    showStorePickupOverlay,
    storePickupOverlay,
    showAddressBookOverlay,
    addressBookOverlay,
}: PageLayoutProps) => {
    return (
        <PageLayoutWrapper>
            {showHeader && header}
            {showCompactHeader && compactHeader}
            {showBreadcrumbs && (
                <Page as="div" {...styles.breadcrumbWrapper}>
                    <PageBreadcrumbs />
                </Page>
            )}
            <StyledWrapper {...styles.wrapper}>{pageContent}</StyledWrapper>
            {showFooter && footer}
            {showSignInOverlay && signInOverlay}
            {showStorePickupOverlay && storePickupOverlay}
            {showAddressBookOverlay && addressBookOverlay}
        </PageLayoutWrapper>
    );
};

const PageLayoutWrapper = styled.div`
    display: flex;
    min-height: 100vh;
    flex-direction: column;
    > main {
        flex: 1 1 0%;
    }

    @media print {
        display: block;
    }
`;

export default PageLayout;
